import { Suspense } from 'react';

import { PublishDetails } from './PublishDetails';

export function PublishBody() {
    return (
        <Suspense fallback={<PublishDialogSkeleton />}>
            <div className="flex w-[396px] flex-col gap-4">
                <PublishDetails />
            </div>
        </Suspense>
    );
}

function PublishDialogSkeleton() {
    return (
        <div className="flex w-[396px] flex-col justify-center gap-4">
            <div className="h-6 w-full rounded-md bg-secondary motion-safe:animate-pulse" />
            <div className="h-12 w-full rounded-md bg-secondary motion-safe:animate-pulse" />
            <div className="h-24 w-full rounded-md bg-secondary motion-safe:animate-pulse" />
        </div>
    );
}
